import Plyr from 'plyr';

export const player = () => {
	const player = new Plyr('#player');
}